<script lang="ts">
	import type { Snippet } from "svelte";
	import type { HTMLSelectAttributes } from "svelte/elements";

	const { options, ...rest }: HTMLSelectAttributes & { options: Snippet } = $props();
</script>

<select
	{...rest}
	class={[
		"rounded-lg border min-h-[3.125rem] shadow-sm border-sage/30 bg-white/80 [&:user-invalid]:border-copper-300 transition-[outline,text,border] duration-300 focus:border-sage focus:bg-white focus:[&:user-invalid]:outline-copper-300 outline-transparent outline-1 outline outline-offset-1 p-3 cursor-pointer",
		rest.class,
	]}
	oninvalid={(event: Event & { currentTarget: EventTarget & HTMLSelectElement }): void => {
		event.preventDefault();
		rest.oninvalid?.(event);
	}}
>
	{@render options()}
</select>
